import * as React from 'react'
function SvgWalletLine(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M24 4c1.2 0 2 .8 2 2v6h8c1.2 0 2 .8 2 2v20c0 1.2-.8 2-2 2H10c-3.4 0-6-2.6-6-6V10c0-3.4 2.6-6 6-6zm8 12H8v14c0 1.2.8 2 2 2h22V16zm-4 6a2 2 0 110 4 2 2 0 010-4zM22 8H10c-1.2 0-2 .8-2 2v2h14V8z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgWalletLine
